<template>
  <v-card-text class="pt-6">
    <div class="d-flex align-center ga-3">
      <v-icon color="red" size="30">mdi-alert-circle</v-icon>

      <div>
        <div class="text-body-1">
          {{ message }}
          <b>{{ mainValue }}</b>
        </div>

        <div class="text-body-2 text-medium-emphasis mt-1">
          {{ warningText }}
        </div>
      </div>
    </div>

    <v-divider class="my-6" />

    <div class="text-body-2">
      <template v-for="(item, i) in details" :key="i">
      <b>{{ item.label }}:</b> {{ item.value }} ·
      <span v-if="i < details.lenght -1 ">.</span>
    </template>
    </div>
  </v-card-text>
</template>
<script>
export default {
  name: "DeleteInfo",

  props: {
    message: {type: String, required:true},
    mainValue: {type: [String, Number], default: "" },
    warningText: {type: String, default:""},
    details:{
      type:Array,
      default: ()=> [],

    },
    icon: { type: String, default: "mdi-alert-circle" },
    iconColor: { type: String, default: "red" },

  },
}

  
</script>